import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner, Container, Row, Col } from 'react-bootstrap';

const ProtectedRoute = ({ children, adminOnly = false, superAdminOnly = false }) => {
  const { isAuthenticated, loading, user, isAdmin, isSuperAdmin } = useAuth();

  // Mostrar spinner mientras carga
  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <Row>
          <Col className="text-center">
            <Spinner animation="border" variant="primary" className="spinner-border-custom" />
            <p className="mt-3 text-muted">Cargando...</p>
          </Col>
        </Row>
      </Container>
    );
  }

  // Redirigir a login si no está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar permisos de super admin si es requerido
  if (superAdminOnly && !isSuperAdmin()) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            <div className="card-custom p-4">
              <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
              <h3 className="mt-3 text-danger">Acceso Denegado</h3>
              <p className="text-muted">
                No tienes permisos para acceder a esta sección. 
                Se requieren privilegios de super administrador.
              </p>
              <button 
                className="btn btn-primary-custom"
                onClick={() => window.history.back()}
              >
                <i className="fas fa-arrow-left me-2"></i>
                Volver
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  // Verificar permisos de admin si es requerido
  if (adminOnly && !isAdmin()) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            <div className="card-custom p-4">
              <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
              <h3 className="mt-3 text-danger">Acceso Denegado</h3>
              <p className="text-muted">
                No tienes permisos para acceder a esta sección. 
                Se requieren privilegios de administrador.
              </p>
              <p className="small text-muted">
                Tu rol actual: <strong>{user?.role}</strong>
              </p>
              <button 
                className="btn btn-primary-custom"
                onClick={() => window.history.back()}
              >
                <i className="fas fa-arrow-left me-2"></i>
                Volver
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return children;
};

export default ProtectedRoute;